import React from "react";

function BeResponsible() {
  return (
    <div className="container">
        <p className="title-3">Be Responsible</p>
        <p className="paragraph">Nous travaillons encore sur cette page. Revenez bientôt !</p>
    </div>
  );
}

export default BeResponsible;